/* =========================
   PRODUCT BACKORDER LOGIC
========================= */

let __enforcing = false;

async function enforceBackorderState() {

	if (__enforcing) return;
	__enforcing = true;

	try {

		const cart = await fetch('/cart.js').then(r => r.json());

		for (const item of cart.items) {

			const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
			const variant = product.variants.find(v => v.id == item.variant_id);

			const inventory = variant?.inventory_quantity ?? 0;

			const mustBeBackorder =
				variant?.inventory_policy === 'continue' &&
				item.quantity > inventory;

			const tagged = item.properties?.['Order Type'] === 'Backorder';

			if (mustBeBackorder && !tagged) {

				await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: item.key, quantity: 0 })
				});

                await new Promise(r => setTimeout(r, 80));

				await fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: item.variant_id,
						quantity: item.quantity,
						properties: { 'Order Type': 'Backorder' }
					})
				});
			}
		}

	} finally {
		__enforcing = false;
	}
}

(function () {

	const SELECTORS = {
		form: 'product-form, form[action="/cart/add"]',
		variantInput: 'input[name="id"]',
		addWrap: '.btn-in-stock',
		backWrap: '.btn-out-of-stock'
	};

	const productJsonEl = document.querySelector('#custom-product-json');
	if (!productJsonEl) return;

	const productData = JSON.parse(productJsonEl.textContent);

	let cartCache = null;
	let cartTime = 0;

	async function getCart() {
		if (Date.now() - cartTime < 300 && cartCache) return cartCache;
		cartCache = await fetch('/cart.js').then(r => r.json());
		cartTime = Date.now();
		return cartCache;
	}

	function getVariantData(variantId) {
		return productData.variants.find(v => String(v.id) === String(variantId));
	}

	function toggleUI(form, backorder) {

		const container = form.closest('.product__info-container');

		if (!container) return;

		const add = container.querySelector('.btn-in-stock');
		const back = container.querySelector('.btn-out-of-stock');

		if (!add || !back) return;

		add.classList.toggle('hidden', backorder);
		back.classList.toggle('hidden', !backorder);
	}

	const variantObserver = new MutationObserver(() => {
		const form = document.querySelector('product-form');
		if (form) window.__backorderEvaluate?.(form);
	});

	document.querySelectorAll('input[name="id"]').forEach(el => {
		variantObserver.observe(el, { attributes: true, attributeFilter: ['value'] });
	});

	async function evaluate(form) {
		if (!form) return;

		const input = form.querySelector(SELECTORS.variantInput);
		if (!input) return;

		const variantId = input.value;
		const variant = getVariantData(variantId);
		if (!variant) return;

		const cart = await getCart();
		const item = cart.items.find(i => i.variant_id == variantId);
		const cartQty = item ? item.quantity : 0;

		const stock = variant.inventory_quantity ?? 0;

		const backorder =
			variant.inventory_policy === 'continue' &&
			(stock <= 0 || cartQty >= stock);

		toggleUI(form, backorder);

		const warning = document.querySelector('.stock-warning');
		const remaining = variant.inventory_quantity - cartQty;

		if (warning) {
			if (remaining > 0 && remaining <= 3) {
				warning.textContent = `Only ${remaining} left`;
				warning.classList.remove('hidden');
			} else {
				warning.classList.add('hidden');
			}
		}
	}

	window.__backorderEvaluate = evaluate;

	function run() {
		document.querySelectorAll(SELECTORS.form).forEach(evaluate);
	}

	const wait = setInterval(() => {
		if (document.querySelector('product-form')) {
			clearInterval(wait);
			run();
		}
	}, 120);

	document.addEventListener('change', e => {
		const form = e.target.closest(SELECTORS.form);
		if (form) setTimeout(() => evaluate(form), 150);
	});

})();


/* =========================
   POPUP BACKORDER CONFIRM
========================= */

document.getElementById('confirmBackorder')?.addEventListener('click', async (e) => {

	const btn = e.currentTarget;
	if (btn.dataset.loading) return;
	btn.dataset.loading = '1';

	const spinner = btn.querySelector('.loading__spinner');
	const label = btn.querySelector('span');

	btn.disabled = true;
	spinner?.classList.remove('hidden');
	label && (label.style.opacity = '0');

	try {
		const form = document.querySelector('product-form');
		if (!form) return;

		const variantId = form.querySelector('input[name="id"]').value;
		const qty = Number(form.querySelector('input[name="quantity"]')?.value || 1);

		const cart = await fetch('/cart.js').then(r => r.json());
		const item = cart.items.find(i => i.variant_id == variantId);

		if (item) {
			await fetch('/cart/change.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ id: item.key, quantity: 0 })
			});

            await new Promise(r => setTimeout(r, 80));

			await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: variantId,
					quantity: item.quantity + qty,
					properties: { 'Order Type': 'Backorder' }
				})
			});

		} else {
			await fetch('/cart/add.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					id: variantId,
					quantity: qty,
					properties: { 'Order Type': 'Backorder' }
				})
			});
		}

		closeBackorderPopup();

		await refreshCartUI();
		syncProductButton();

	} finally {
		btn.disabled = false;
		spinner?.classList.add('hidden');
		label && (label.style.opacity = '1');
		delete btn.dataset.loading;
	}
});


/* =========================
   DRAWER BACKORDER FIX
========================= */

let __backorderFixRunning = false;

async function handleDrawerBackorderFix() {


	if (__backorderFixRunning) return;
	__backorderFixRunning = true;

	try {
		const cart = await fetch('/cart.js').then(r => r.json());

		for (const item of cart.items) {

			const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
			const variant = product.variants.find(v => v.id == item.variant_id);

			const inventory = variant?.inventory_quantity ?? 0;

			const shouldBackorder =
				variant?.inventory_policy === 'continue' &&
				item.quantity > inventory;

			const isTagged = item.properties?.['Order Type'] === 'Backorder';

			/* ⭐ CASE 1 — needs backorder but not tagged */
			if (shouldBackorder && !isTagged) {

				await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: item.key, quantity: 0 })
				});

                await new Promise(r => setTimeout(r, 80));

				await fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: item.variant_id,
						quantity: item.quantity,
						properties: { 'Order Type': 'Backorder' }
					})
				});
			}

			/* ⭐ CASE 2 — no longer backorder but still tagged */
			if (!shouldBackorder && isTagged) {

				await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: item.key, quantity: 0 })
				});

                await new Promise(r => setTimeout(r, 80));

				await fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: item.variant_id,
						quantity: item.quantity
					})
				});
			}
		}

	} finally {
		__backorderFixRunning = false;
		syncProductButton();
	}

	const __inventoryCache = {};

	async function getInventory(item) {
		if (__inventoryCache[item.variant_id] !== undefined) {
			return __inventoryCache[item.variant_id];
		}

		try {
			const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
			const variant = product.variants.find(v => v.id == item.variant_id);
			return __inventoryCache[item.variant_id] = variant?.inventory_quantity ?? 0;
		} catch {
			return 0;
		}
	}
}

document.addEventListener('click', e => {
	if (e.target.closest('.quantity__button')) {
		setTimeout(handleDrawerBackorderFix, 600);
	}
});

document.addEventListener('change', e => {
	if (e.target.closest('.quantity__input')) {
		setTimeout(handleDrawerBackorderFix, 600);
	}
});


/* =========================
   CLOSE POPUP
========================= */

function closeBackorderPopup() {
	const popup = document.getElementById('backorder-form');
	if (popup) popup.style.display = 'none';
	document.body.classList.remove('backorder-open');
}

document.getElementById('cancelBackorder')?.addEventListener('click', closeBackorderPopup);
document.addEventListener('click', e => {
	if (e.target.closest('.btn-out-of-stock')) {
		e.preventDefault();
	}
});

/* =========================
   CHECKOUT INVENTORY HELPER
========================= */

const __checkoutInventoryCache = {};

async function getCheckoutInventory(item) {
	if (__checkoutInventoryCache[item.variant_id] !== undefined) {
		return __checkoutInventoryCache[item.variant_id];
	}

	try {
		const product = await fetch(`/products/${item.handle}.js`).then(r => r.json());
		const variant = product.variants.find(v => v.id == item.variant_id);
		return __checkoutInventoryCache[item.variant_id] = variant?.inventory_quantity ?? 0;
	} catch {
		return 0;
	}
}


/* =========================
   CHECKOUT PROPERTY FIX (SAFE)
========================= */

document.addEventListener('submit', async function (e) {

	const form = e.target.closest('form[action="/checkout"]');
	if (!form) return;

	e.preventDefault();

	try {

		const cart = await fetch('/cart.js').then(r => r.json());

		for (const item of cart.items) {

			const inventory = await getCheckoutInventory(item);

			const isBackorder =
				item.variant_inventory_policy === 'continue' &&
				item.quantity > inventory;

			const tagged = item.properties?.['Order Type'] === 'Backorder';

			if (isBackorder && !tagged) {

				await fetch('/cart/change.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ id: item.key, quantity: 0 })
				});

                await new Promise(r => setTimeout(r, 80));

				await fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						id: item.variant_id,
						quantity: item.quantity,
						properties: { 'Order Type': 'Backorder' }
					})
				});
			}
		}

	} catch (err) {
		console.warn('checkout backorder fix failed');
	}

	/* allow cart to settle before redirect */
	setTimeout(() => {
		window.location.href = '/checkout';
	}, 180);

});

/* =========================
   CHECKOUT CLICK FALLBACK
========================= */

document.addEventListener('click', async e => {
	if (!e.target.closest('[name="checkout"], .cart__checkout-button')) return;

	e.preventDefault();

	await enforceBackorderState();

	setTimeout(() => {
		window.location.href = '/checkout';
	}, 150);
});


async function refreshCartUI() {

	try {

		cartCache = null;
		cartTime = 0;

		const res = await fetch('/?section_id=cart-drawer');
		const html = await res.text();

		const div = document.createElement('div');
		div.innerHTML = html;

		const newDrawer = div.querySelector('cart-drawer');
		const oldDrawer = document.querySelector('cart-drawer');

		if (newDrawer && oldDrawer) {
			oldDrawer.replaceWith(newDrawer);
			newDrawer.open?.();
		}

		/* ⭐ update header bubble */

		const cart = await fetch('/cart.js').then(r => r.json());

		document.querySelectorAll('[data-cart-count]').forEach(el => {
			el.textContent = cart.item_count;
		});

	} catch (e) {
		console.warn('drawer refresh failed');
	}
}

function syncProductButton() {
	setTimeout(() => {
		const form = document.querySelector('product-form');
		window.__backorderEvaluate?.(form);
	}, 250);
}

/* =========================
   EVENT SYNC
========================= */

document.addEventListener('cart:update', () => {
	const form = document.querySelector('product-form');
	if (form) window.__backorderEvaluate?.(form);
});

document.addEventListener('click', e => {
	if (e.target.closest('.cart-remove-button')) {
		setTimeout(syncProductButton, 350);
	}
});

document.addEventListener('submit', e => {
	if (e.target.closest('product-form')) {
		setTimeout(syncProductButton, 500);
	}
});

document.addEventListener('variant:change', syncProductButton);

const drawerObserver = new MutationObserver(() => {
	clearTimeout(window.__boTimer);
	window.__boTimer = setTimeout(enforceBackorderState, 300);
});

function watchDrawer() {
	const drawer = document.querySelector('cart-drawer');
	if (!drawer) return;

	drawerObserver.observe(drawer, {
		childList: true,
		subtree: true
	});
}

setTimeout(watchDrawer, 800);

window.addEventListener('load', () => {
	setTimeout(enforceBackorderState, 400);
});

(function () {

  const originalFetch = window.fetch;

  window.fetch = async function () {

    const res = await originalFetch.apply(this, arguments);

    const url = arguments[0];

    if (typeof url === 'string' && url.includes('/cart/')) {
      clearTimeout(window.__boFetchTimer);
      window.__boFetchTimer = setTimeout(handleDrawerBackorderFix, 250);
    }

    return res;
  };

})();